import React from 'react';

import { Button, Alert } from '@gogame/components';

const IOSWarning = ({ onInvoiceChangeLevel }) => {
  return (
    <Alert
      severity={'warning'}
      title={'For selected period and business partner IO already exists.'}
      action={
        <Button onClick={onInvoiceChangeLevel} color={'inherit'}>
          Change Invoice Level
        </Button>
      }
    >
      Change the BP invoice level to «affiliate» for creating the IO for the
      same period
    </Alert>
  );
};

export default IOSWarning;
